export const FETCH_NOTES = 'scenes/VehicleDetail/Sinister/Notifications/fetch_notes'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notes/constants.js